import { render, staticRenderFns } from "./LicenseDetailDialog.vue?vue&type=template&id=c08fbb34&scoped=true&"
import script from "./LicenseDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./LicenseDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseDetailDialog.vue?vue&type=style&index=0&id=c08fbb34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08fbb34",
  null
  
)

export default component.exports